export default __webpack_public_path__ + "static/media/ic_github.dbd4de8a.svg";